import {booleanPipe, measurePipe, numberPipe, percentPipe} from "./pipeFormaters";
import {Button, Tooltip} from "antd";
import {sendCommand} from "./commands";
import TableConfigCell from "../TableConfig/TableConfigCell";
import DeleteRowButton from "../TableConfig/DeleteRowButton";
import NavigateDevice from "../Tables/NavigateDevice";

export const mapDynamicTableHeader = (tableMeta, tableId = null, installationID = null) => {

    let headerArray = []
    headerArray.push({
        title: "Lokacija",
        dataIndex: "location",
        key: "location",
        render: (text) => {
            return `${text.value}`
        },
        width: "200px"
    })

    headerArray = [...headerArray, ...tableMeta.map((column) => {
        return {
            title: column.title,
            dataIndex: column.id,
            key: column.id,
            render: (text) => {
                if (text) {
                    return <TableConfigCell tableId={tableId} installationID={installationID} cell={text}/>
                }
            },
            width: "200px"
        }
    })]

    headerArray.push({
        title: "Akcije",
        dataIndex: "actions",
        key: "actions",
        render: (value, cell) => {
            return (
                <DeleteRowButton tableId={tableId} cell={cell}/>
            )
        }
    })

    return headerArray
}

export const mapTableHeader = (tableMeta, viewer) => {

    let headerArray = []

    headerArray.push({
        title: <Tooltip title="Device Location">
            <span>Location</span>
        </Tooltip>, dataIndex: "location", key: "location", render: (cell) => {
            return <NavigateDevice cell={cell}/>
        }, sorter: (a, b) => a.location.value.localeCompare(b.location.value),
        align: "left"
    })


    headerArray = [...headerArray, ...tableMeta.columns.map((column) => {
        if (column.type === "DATA") {
            switch (column.pipe) {
                case "boolean":
                    return {
                        title: <Tooltip title={column.description}>
                            <span>{column.title}</span>
                        </Tooltip>, dataIndex: column.id, key: column.id, render: (text) => {
                            return (<button
                                className={(text.value === true || text.value === 1) ? "ant-table-td-on cursor-flux" : "ant-table-td-off cursor-flux"}>
                                {booleanPipe(text.value, column.pipeArg)}
                            </button>)
                        }, sorter: (a, b) => a[column.id].value - b[column.id].value,
                        align: `${column.alignment}`
                    }
                case "percent":
                    return {
                        title: <Tooltip title={column.description}>
                            <span>{column.title}</span>
                        </Tooltip>, dataIndex: column.id, key: column.id, render: (text) => {
                            return percentPipe(text.value, column.pipeArg)
                        }, sorter: (a, b) => a[column.id].value - b[column.id].value,
                        align: `${column.alignment}`
                    }
                case "measure":
                    return {
                        title: <Tooltip title={column.description}>
                            <span>{column.title}</span>
                        </Tooltip>, dataIndex: column.id, key: column.id, render: (text) => {
                            return measurePipe(text.value, column.pipeArg)
                        }, sorter: (a, b) => a[column.id].value - b[column.id].value,
                        align: `${column.alignment}`
                    }
                case "number":
                    return {
                        title: <Tooltip title={column.description}>
                            <span>{column.title}</span>
                        </Tooltip>, dataIndex: column.id, key: column.id, render: (text) => {
                            return numberPipe(text.value, column.pipeArg)
                        }, sorter: (a, b) => a[column.id].value - b[column.id].value,
                        align: `${column.alignment}`
                    }

                default:
                    return {
                        title: <Tooltip title={column.description}>
                            <span>{column.title}</span>
                        </Tooltip>, dataIndex: column.id, key: column.id, render: (text) => {
                            return `${text.value}`
                        },
                        align: `${column.alignment}`
                    }
            }

        } else if (column.type === "COMMAND") {
            if (!viewer) {
                return {
                    title: <Tooltip title={column.description}>
                        <span>{column.title}</span>
                    </Tooltip>, dataIndex: column.id, key: column.id, render: (cell) => {
                        return (<Button className={"trigger-button-on-off"} onClick={() => {
                            sendCommand(cell.deviceId, column)
                        }}
                        >{column.title}</Button>)
                    },
                    align: `${column.alignment}`
                }
            }
        } else {
            return {
                title: <Tooltip title={column.description}>
                    <span>{column.title}</span>
                </Tooltip>, dataIndex: column.id, key: column.id, render: (text) => {
                    return `${text.value}`
                },
                align: `${column.alignment}`
            }
        }


    })]

    return headerArray
}

export const joinData = (meta, locations, header) => {

    //Joins locations to table
    let tempRows = meta.rows.map((row) => {
        return {
            ...row, cells: [{
                ...locations.find(loc => loc.id === row.locationId),
                value: locations.find(loc => loc.id === row.locationId)?.name
            }, ...row.cells]
        }
    })
    //Remaps cells to objects so Antd can assemble table
    tempRows = tempRows.map((row) => {

        let reformattedCells = {}

        row.cells.forEach((cell, i) => {
            if (header[i]) {
                let column_id = header[i].key
                reformattedCells = {
                    ...reformattedCells, [column_id]: {
                        ...cell,
                    }
                }
            }
        })
        return {
            ...row, cells: {
                ...reformattedCells
            }
        }
    })
    return tempRows.map((row) => {
        return row.cells
    })
}